import { useEffect } from 'react';
import { useLocalStorage } from '@schemeserve/global-utils';
import { initTawkTo } from './initChatScripts';

const Chat = (): null => {
	const siteSettings = useLocalStorage().getItem('ssSiteSettings') as {
		[key: string]: string;
	};
	useEffect(() => {
		if (
			siteSettings?.chat_tawkto_propertyId &&
			siteSettings?.chat_tawkto_widgetId
		) {
			const {
				chat_tawkto_widgetId: chatTawkToWidgetId,
				chat_tawkto_propertyId: chatTawkToPropertyId,
			} = siteSettings;

			initTawkTo(chatTawkToWidgetId, chatTawkToPropertyId);
		}
	}, [siteSettings]);
	return null;
};

export default Chat;
